import React from "react";

const Logo = ({color,bg,width}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 650 2800 1300"
      xmlSpace="preserve"
      width={width}
    >
      <g>
        <g>
          <path
            fill={color}
            d="M571.73,1284.67c0,81.5,0.31,163-0.15,244.49c-0.18,31.83-21.11,57.01-49.54,63.17
			c-5.29,1.15-10.57,1.45-15.92,1.45c-42.65-0.02-85.3,0.03-127.95-0.09c-3.42-0.01-4.88,0.75-5.58,4.65
			c-8.37,47.1-43.81,82.43-88.46,89.32c-52.16,8.05-108.54-29.92-117.37-94.67c-0.78-5.74-1.03-11.54-1.02-17.36
			c0.05-22.81-0.03-45.63,0.08-68.44c0.02-2.99-0.78-4.32-3.55-5.28c-29.15-10.07-46.92-40.42-42.64-72.52
			c4.23-31.68,29.45-55.58,59.93-56.79c31.12-1.23,58.1,22.49,63.62,55.92c5.18,31.4-13.53,63.84-42.48,73.34
			c-2.83,0.93-3.59,2.27-3.58,5.23c0.1,23.47,0,46.95,0.07,70.42c0.12,40.56,29.14,74.37,66.45,77.5
			c38.74,3.25,72.51-24.7,78.71-65.27c0.69-4.53,0.89-9.19,0.89-13.79c0.06-47.87,0-95.74,0.12-143.61c0.01-3.55-1.08-4.7-4.2-5.29
			c-56.28-10.77-96-60.72-96.33-121.32c-0.19-34.95-0.06-69.89-0.03-104.84c0.01-11.18,6.44-18,16.97-18.03
			c15.92-0.05,31.83-0.05,47.75,0c9.89,0.03,16.73,6.89,16.73,16.59c0,9.65-6.87,16.59-16.74,16.69c-9.95,0.1-19.9,0.12-29.84-0.03
			c-2.83-0.04-3.58,0.97-3.57,3.87c0.09,28.75-0.21,57.5,0.13,86.24c0.53,45.47,30.81,81.96,73.16,88.72
			c48.08,7.67,94.39-32.5,95.86-84.05c0.87-30.44,0.21-60.92,0.32-91.38c0.01-2.63-0.89-3.4-3.26-3.38
			c-10.07,0.09-20.14,0.13-30.21,0.01c-10.37-0.13-17.57-8.23-16.56-18.42c0.81-8.14,6.83-14.64,14.59-14.75
			c17.4-0.24,34.82-0.27,52.22,0.03c8.17,0.14,14.45,7.35,14.47,16.06c0.06,37.72,0.55,75.44-0.17,113.14
			c-0.98,51.6-37.98,99.61-85.63,112.49c-3.97,1.07-7.99,1.95-12.02,2.74c-1.81,0.36-2.5,1.19-2.48,3.15
			c0.06,10.42,0.06,20.84,0.01,31.25c-0.01,2.19,0.82,3.18,2.88,3.05c0.87-0.06,1.74,0,2.61,0c53.96,0,107.93,0,161.89,0
			c5.39,0,5.39,0,5.39-5.54c0-138.99,0-277.99,0-416.98c0-19.63-10.01-34.46-26.72-39.63c-3.72-1.15-7.55-1.53-11.43-1.53
			c-95.99,0.01-191.98-0.01-287.98,0.02c-22.52,0.01-38.18,16.67-38.19,40.67c-0.04,83.87-0.01,167.74-0.02,251.62
			c0,2.37,0.07,4.74-0.5,7.08c-1.42,5.83-6.02,9.55-11.8,9.45c-5.56-0.1-10.08-3.86-11.27-9.62c-0.39-1.91-0.47-3.92-0.47-5.89
			c-0.02-84.14-0.05-168.27,0-252.41c0.02-30.12,16.11-54.28,42.09-63.23c7.08-2.44,14.29-3.86,21.89-3.85
			c94.75,0.14,189.5,0.15,284.25,0.06c33.77-0.03,58.5,24.28,63.38,53.79c0.71,4.32,1.2,8.54,1.2,12.87
			C571.73,1122.72,571.73,1203.7,571.73,1284.67z"
          />
          <path
            fill={color}
            d="M522.67,1039.79c0.08,7.14-5.27,12.94-11.92,12.93c-6.47-0.02-11.9-5.69-12-12.55
			c-0.11-7.02,5.34-12.85,12.02-12.85C517.4,1027.31,522.6,1032.76,522.67,1039.79z"
          />
          <path
            fill={bg}
            d="M461.31,1490.41c27.09,0,54.18,0.07,81.28-0.09c3.8-0.02,4.89,1.17,4.8,5.16c-0.25,10.8-0.03,21.61-0.1,32.42
			c-0.14,23.15-15.88,39.92-37.7,39.96c-43.62,0.08-87.24-0.01-130.86,0.09c-3.25,0.01-4.4-0.96-4.26-4.47
			c0.23-5.92,0.16-11.86,0.02-17.79c-0.07-2.85,0.75-4.07,3.6-3.93c3.84,0.2,7.71,0.14,11.55-0.02c6.74-0.28,11.84-5.88,11.77-12.7
			c-0.08-6.96-5.07-12.35-11.9-12.63c-3.97-0.16-7.95-0.13-11.93-0.02c-2.24,0.06-3.11-0.85-3.07-3.24
			c0.09-6.33,0.19-12.66-0.04-18.98c-0.13-3.47,1.45-3.83,4.08-3.81c16.65,0.07,33.31,0.04,49.96,0.04
			C439.44,1490.41,450.37,1490.41,461.31,1490.41z"
          />
          <path
            fill={bg}
            d="M181.43,1405.86c17.07-0.03,31.07,14.75,31.18,32.93c0.12,18.03-13.91,33.08-30.95,33.21
			c-17.19,0.14-31.38-14.86-31.36-33.16C150.32,1420.74,164.33,1405.89,181.43,1405.86z"
          />
        </g>
        <g>
          <g>
            <path
              fill={color}
              d="M883.91,1384.87c-14.4,26.17-35.25,46.53-62.55,61.08c-27.31,14.56-59.78,21.83-97.39,21.83H600.83v-346.37
				h123.14c37.61,0,70.07,7.11,97.39,21.34c27.31,14.23,48.16,34.34,62.55,60.34c14.39,26,21.59,56.34,21.59,91.01
				C905.49,1328.45,898.3,1358.7,883.91,1384.87z M804.67,1376.53c20.44-19.62,30.66-47.1,30.66-82.42
				c0-35.65-10.23-63.29-30.66-82.91c-20.44-19.62-49.31-29.44-86.59-29.44H670v224.21h48.08
				C755.37,1405.96,784.23,1396.15,804.67,1376.53z"
            />
            <path
              fill={color}
              d="M1154.47,1209.23c21.1,11.12,37.69,27.23,49.8,48.32c12.1,21.1,18.15,45.87,18.15,74.33
				s-6.06,53.15-18.15,74.08c-12.1,20.94-28.7,37.04-49.8,48.33c-21.1,11.28-44.89,16.93-71.38,16.93
				c-26.49,0-50.29-5.64-71.38-16.93c-21.1-11.28-37.7-27.39-49.8-48.33c-12.1-20.93-18.15-45.63-18.15-74.08
				s6.05-53.23,18.15-74.33c12.1-21.1,28.7-37.2,49.8-48.32c21.1-11.12,44.89-16.68,71.38-16.68
				C1109.58,1192.55,1133.37,1198.11,1154.47,1209.23z M1034.03,1272.76c-13.41,13.58-20.11,33.28-20.11,59.12
				c0,25.84,6.7,45.55,20.11,59.12c13.41,13.58,29.76,20.36,49.06,20.36c19.29,0,35.65-6.78,49.06-20.36
				c13.41-13.57,20.12-33.28,20.12-59.12c0-25.83-6.71-45.54-20.12-59.12c-13.42-13.57-29.77-20.36-49.06-20.36
				C1063.79,1252.4,1047.43,1259.19,1034.03,1272.76z"
            />
            <path
              fill={color}
              d="M1481.21,1221c23.38,18.97,38.02,44.81,43.91,77.52h-73.1c-2.94-14.39-9.65-25.76-20.11-34.1
				c-10.47-8.34-23.72-12.51-39.74-12.51c-18.32,0-33.61,6.79-45.87,20.36c-12.26,13.58-18.4,33.45-18.4,59.61
				c0,26.17,6.13,46.04,18.4,59.61c12.27,13.58,27.55,20.36,45.87,20.36c16.02,0,29.27-4.17,39.74-12.51
				c10.46-8.34,17.17-19.7,20.11-34.1h73.1c-5.89,32.71-20.53,58.55-43.91,77.52c-23.39,18.97-52.58,28.46-87.57,28.46
				c-26.49,0-50.04-5.64-70.65-16.93c-20.61-11.28-36.63-27.39-48.08-48.33c-11.45-20.93-17.17-45.63-17.17-74.08
				s5.72-53.23,17.17-74.33c11.44-21.1,27.47-37.2,48.08-48.32c20.61-11.12,44.15-16.68,70.65-16.68
				C1428.64,1192.55,1457.83,1202.04,1481.21,1221z"
            />
            <path
              fill={color}
              d="M2022.1,1345.13h-199.19c0.98,24.21,7.52,42.03,19.62,53.48c12.1,11.45,27.14,17.17,45.14,17.17
				c16.02,0,29.35-3.92,39.98-11.77c10.63-7.85,17.42-18.47,20.36-31.89h73.1c-3.6,18.97-11.28,35.98-23.06,51.02
				c-11.77,15.05-26.91,26.82-45.38,35.32c-18.48,8.51-39,12.76-61.57,12.76c-26.49,0-50.04-5.64-70.65-16.93
				c-20.61-11.28-36.63-27.39-48.08-48.33c-11.45-20.93-17.17-45.63-17.17-74.08s5.72-53.23,17.17-74.33
				c11.45-21.1,27.47-37.2,48.08-48.32c20.61-11.12,44.15-16.68,70.65-16.68c26.81,0,50.29,5.57,70.4,16.68
				c20.11,11.12,35.65,26.42,46.61,45.87c10.95,19.46,16.43,41.63,16.43,66.48C2024.55,1328.45,2023.73,1336.3,2022.1,1345.13z
				 M1937.47,1264.18c-12.59-11.44-28.05-17.17-46.36-17.17c-18.64,0-34.34,5.73-47.1,17.17c-12.75,11.45-19.79,28.29-21.1,50.53
				h131.97C1955.86,1292.47,1950.05,1275.63,1937.47,1264.18z"
            />
            <path
              fill={color}
              d="M2183.01,1207.02c16.68-9.97,35.32-14.96,55.93-14.96v74.08h-20.11c-50.7,0-76.04,23.55-76.04,70.65v130.99
				h-69.18v-271.8h69.18v52C2152.91,1230.66,2166.33,1217,2183.01,1207.02z"
            />
            <path
              fill={color}
              d="M2346.38,1195.98v271.8h-69.18v-271.8H2346.38z"
            />
            <path
              fill={color}
              d="M2606.15,1209.23c21.1,11.12,37.69,27.23,49.8,48.32c12.1,21.1,18.15,45.87,18.15,74.33
				s-6.06,53.15-18.15,74.08c-12.1,20.94-28.7,37.04-49.8,48.33c-21.1,11.28-44.89,16.93-71.38,16.93
				c-26.49,0-50.29-5.64-71.38-16.93c-21.1-11.28-37.7-27.39-49.8-48.33c-12.1-20.93-18.15-45.63-18.15-74.08
				s6.05-53.23,18.15-74.33c12.1-21.1,28.7-37.2,49.8-48.32c21.1-11.12,44.89-16.68,71.38-16.68
				C2561.26,1192.55,2585.06,1198.11,2606.15,1209.23z M2485.71,1272.76c-13.42,13.58-20.12,33.28-20.12,59.12
				c0,25.84,6.7,45.55,20.12,59.12c13.41,13.58,29.76,20.36,49.06,20.36c19.29,0,35.65-6.78,49.06-20.36
				c13.41-13.57,20.11-33.28,20.11-59.12c0-25.83-6.71-45.54-20.11-59.12c-13.42-13.57-29.77-20.36-49.06-20.36
				C2515.47,1252.4,2499.11,1259.19,2485.71,1272.76z"
            />
          </g>
          <g>
            <path
              fill={color}
              d="M1746.54,1329.57c0,9.39,0.03,18.78-0.01,28.17c-0.04,9.86-5.9,15.93-15.87,16.04
				c-13.83,0.16-27.67,0.15-41.51-0.03c-3.28-0.04-4.43,0.62-4.37,4.19c0.23,13.46,0.11,26.93,0.09,40.4
				c-0.02,11.42-5.96,17.35-17.37,17.36c-18.04,0.01-36.08-0.24-54.11,0.1c-10.19,0.19-17.66-6.73-17.3-17.1
				c0.47-13.7,0-27.42,0.2-41.13c0.05-3.21-0.95-3.83-3.95-3.8c-13.71,0.16-27.42,0.02-41.14,0.09c-6.38,0.03-11.61-1.91-14.96-7.69
				c-1.49-2.56-1.84-5.36-1.84-8.21c-0.03-18.9-0.09-37.8,0.01-56.7c0.06-10.16,6.02-15.93,16.28-15.98
				c13.96-0.07,27.92-0.09,41.88,0.05c2.83,0.03,3.75-0.58,3.71-3.6c-0.18-14.08-0.1-28.17-0.07-42.25
				c0.02-9.48,5.76-15.94,15.13-16.06c19.39-0.25,38.79-0.25,58.18,0c9.43,0.12,15.28,6.67,15.33,16.39
				c0.07,13.96,0.11,27.92-0.05,41.88c-0.03,2.97,0.8,3.69,3.71,3.66c13.71-0.16,27.42-0.1,41.14-0.06
				c11.08,0.02,16.86,5.84,16.88,16.89C1746.55,1311.29,1746.54,1320.43,1746.54,1329.57z"
            />
            <path
              fill={bg}
              d="M1691.92,1314.87c7.41,0,14.82,0.09,22.23-0.05c2.3-0.04,2.92,0.63,2.88,2.92
				c-0.15,7.78-0.17,15.56,0.01,23.33c0.06,2.5-0.71,3.07-3.08,3.05c-13.83-0.1-27.66-0.06-41.49-0.05
				c-11.38,0.01-17.36,5.96-17.38,17.34c-0.03,13.71-0.08,27.41,0.06,41.12c0.03,2.77-0.69,3.58-3.5,3.51
				c-7.53-0.2-15.07-0.23-22.59,0.01c-2.95,0.09-3.41-0.92-3.38-3.56c0.13-14.08,0.08-28.15,0.05-42.23
				c-0.02-9.93-6.15-16.11-16.18-16.17c-14.08-0.07-28.15-0.08-42.23,0.04c-2.54,0.02-3.35-0.55-3.28-3.21
				c0.2-7.4,0.21-14.82,0-22.22c-0.09-2.96,0.54-3.96,3.75-3.92c13.83,0.2,27.66,0.1,41.49,0.08c10.53-0.02,16.45-5.98,16.46-16.52
				c0.02-13.83,0.12-27.66-0.08-41.49c-0.05-3.19,0.9-3.86,3.9-3.77c7.28,0.23,14.57,0.2,21.85,0.01c2.85-0.08,3.79,0.61,3.75,3.64
				c-0.17,13.46-0.07,26.92-0.08,40.38c0,12.04,5.64,17.75,17.59,17.76C1679.08,1314.87,1685.5,1314.87,1691.92,1314.87z"
            />
          </g>
          <g>
            <path
              fill={color}
              d="M665.73,1512.83v70.6h-14.2v-30.7h-30.2v30.7h-14.1v-70.6h14.1v28.6h30.2v-28.6H665.73z"
            />
            <path
              fill={color}
              d="M704.43,1524.03v18.3h25v10.8h-25v19h28v11.3h-42.1v-70.6h42.1v11.2H704.43z"
            />
            <path
              fill={color}
              d="M797.63,1569.23h-28.3l-5,14.2h-14.9l26-69.8h16.1l25.9,69.8h-14.9L797.63,1569.23z M793.83,1558.53
				l-10.4-29.8l-10.4,29.8H793.83z"
            />
            <path
              fill={color}
              d="M850.93,1572.63h23.7v10.8h-37.8v-70.6h14.1V1572.63z"
            />
            <path
              fill={color}
              d="M942.83,1512.83v11.2h-19.5v59.4h-14.1v-59.4h-19.4v-11.2H942.83z"
            />
            <path
              fill={color}
              d="M1020.93,1512.83v70.6h-14.2v-30.7h-30.2v30.7h-14.1v-70.6h14.1v28.6h30.2v-28.6H1020.93z"
            />
            <path
              fill={color}
              d="M1099.33,1518.93c5.8,4.53,9.63,10.7,11.5,18.5h-14.8c-1.53-3.8-3.92-6.8-7.15-9
				c-3.23-2.2-7.12-3.3-11.65-3.3c-3.73,0-7.1,0.93-10.1,2.8c-3,1.87-5.33,4.53-7,8c-1.67,3.47-2.5,7.53-2.5,12.2
				c0,4.6,0.83,8.63,2.5,12.1c1.67,3.47,4,6.13,7,8c3,1.87,6.37,2.8,10.1,2.8c4.53,0,8.42-1.1,11.65-3.3c3.23-2.2,5.62-5.2,7.15-9
				h14.8c-1.87,7.8-5.7,13.97-11.5,18.5c-5.8,4.53-13.1,6.8-21.9,6.8c-6.73,0-12.68-1.52-17.85-4.55c-5.17-3.03-9.17-7.28-12-12.75
				c-2.83-5.47-4.25-11.67-4.25-18.6c0-7,1.42-13.23,4.25-18.7c2.83-5.47,6.82-9.72,11.95-12.75c5.13-3.03,11.1-4.55,17.9-4.55
				C1086.23,1512.13,1093.53,1514.4,1099.33,1518.93z"
            />
            <path
              fill={color}
              d="M1176.22,1569.23h-28.3l-5,14.2h-14.9l26-69.8h16.1l25.9,69.8h-14.9L1176.22,1569.23z M1172.42,1558.53
				l-10.4-29.8l-10.4,29.8H1172.42z"
            />
            <path
              fill={color}
              d="M1252.22,1583.43l-16.5-27.5h-6.2v27.5h-14.1v-70.6h26.9c8.2,0,14.45,2,18.75,6c4.3,4,6.45,9.27,6.45,15.8
				c0,5.33-1.48,9.8-4.45,13.4c-2.97,3.6-7.25,6-12.85,7.2l17.6,28.2H1252.22z M1229.52,1546.23h11.6c8.07,0,12.1-3.57,12.1-10.7
				c0-3.4-0.98-6.05-2.95-7.95c-1.97-1.9-5.02-2.85-9.15-2.85h-11.6V1546.23z"
            />
            <path
              fill={color}
              d="M1302.92,1524.03v18.3h25v10.8h-25v19h28v11.3h-42.1v-70.6h42.1v11.2H1302.92z"
            />
            <path
              fill={color}
              d="M1432.52,1574.08c-1.8,3.03-4.47,5.47-8,7.3c-3.54,1.83-7.84,2.75-12.9,2.75c-5,0-9.47-0.85-13.4-2.55
				c-3.93-1.7-7.08-4.15-9.45-7.35c-2.37-3.2-3.72-6.93-4.05-11.2h15c0.33,2.87,1.48,5.25,3.45,7.15c1.97,1.9,4.58,2.85,7.85,2.85
				c2.93,0,5.18-0.78,6.75-2.35c1.56-1.57,2.35-3.58,2.35-6.05c0-2.2-0.63-4.02-1.9-5.45c-1.27-1.43-2.87-2.58-4.8-3.45
				c-1.93-0.87-4.6-1.87-8-3c-4.4-1.47-8-2.92-10.8-4.35c-2.8-1.43-5.18-3.52-7.15-6.25c-1.97-2.73-2.95-6.3-2.95-10.7
				c0-6.07,2.18-10.85,6.55-14.35c4.37-3.5,10.15-5.25,17.35-5.25c7.47,0,13.42,1.8,17.85,5.4c4.43,3.6,6.95,8.4,7.55,14.4h-15.2
				c-0.4-2.53-1.47-4.62-3.2-6.25c-1.73-1.63-4.1-2.45-7.1-2.45c-2.6,0-4.7,0.68-6.3,2.05c-1.6,1.37-2.4,3.35-2.4,5.95
				c0,2.07,0.62,3.78,1.85,5.15c1.23,1.37,2.8,2.48,4.7,3.35c1.9,0.87,4.48,1.83,7.75,2.9c4.53,1.6,8.22,3.1,11.05,4.5
				c2.83,1.4,5.25,3.5,7.25,6.3s3,6.47,3,11C1435.22,1567.73,1434.32,1571.05,1432.52,1574.08z"
            />
            <path fill={color} d="M1471.52,1512.83v70.6h-14.1v-70.6H1471.52z" />
            <path
              fill={color}
              d="M1572.22,1513.63v69.8h-14v-48.7l-17.9,48.7h-12.2l-17.9-48.5v48.5h-14.1v-69.8h17.1l21.2,52.5l20.8-52.5
				H1572.22z"
            />
            <path
              fill={color}
              d="M1610.92,1557.23v26.2h-14.1v-70.6h25.7c8.33,0,14.62,2,18.85,6c4.23,4,6.35,9.43,6.35,16.3
				c0,6.73-2.18,12.1-6.55,16.1c-4.37,4-10.58,6-18.65,6H1610.92z M1633.42,1535.13c0-3.53-0.97-6.23-2.9-8.1
				c-1.93-1.87-5.1-2.8-9.5-2.8h-10.1v21.7h10.1C1629.29,1545.93,1633.42,1542.33,1633.42,1535.13z"
            />
            <path
              fill={color}
              d="M1682.82,1572.63h23.7v10.8h-37.8v-70.6h14.1V1572.63z"
            />
            <path fill={color} d="M1740.82,1512.83v70.6h-14.1v-70.6H1740.82z" />
            <path
              fill={color}
              d="M1809.22,1512.83v11.2h-29.7v18.9h23.8v10.8h-23.8v29.7h-14.1v-70.6H1809.22z"
            />
            <path fill={color} d="M1844.62,1512.83v70.6h-14.1v-70.6H1844.62z" />
            <path
              fill={color}
              d="M1883.32,1524.03v18.3h25v10.8h-25v19h28v11.3h-42.1v-70.6h42.1v11.2H1883.32z"
            />
            <path
              fill={color}
              d="M1991.21,1566.53c-2.93,5.33-7.18,9.48-12.75,12.45c-5.57,2.97-12.18,4.45-19.85,4.45h-25.1v-70.6h25.1
				c7.67,0,14.28,1.45,19.85,4.35s9.82,7,12.75,12.3s4.4,11.48,4.4,18.55C1995.62,1555.03,1994.15,1561.2,1991.21,1566.53z
				 M1975.07,1564.83c4.17-4,6.25-9.6,6.25-16.8c0-7.27-2.08-12.9-6.25-16.9c-4.17-4-10.05-6-17.65-6h-9.8v45.7h9.8
				C1965.02,1570.83,1970.9,1568.83,1975.07,1564.83z"
            />
          </g>
        </g>
        <g>
          <path
            fill={color}
            d="M2283.93,1097.5c7.07-6.33,16.36-9.51,27.86-9.51c11.5,0,20.78,3.17,27.86,9.51
			c7.08,6.34,10.61,14.52,10.61,24.54c0,9.73-3.54,17.76-10.61,24.1c-7.07,6.34-16.36,9.51-27.86,9.51
			c-11.5,0-20.78-3.16-27.86-9.51c-7.08-6.33-10.61-14.37-10.61-24.1C2273.32,1112.02,2276.86,1103.84,2283.93,1097.5z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Logo;
